<template>
    <main class="visit-page">
        <section class="visit-shell">
            <!-- HEADER -->
             <app-header @show-drawer="showDrawer" @logout="logout" heading="User Management" subHeading="Create user accounts, assign roles, and link dealers only where required." :isFormPage="true"  />
            <!-- <div v-if="$q.screen.lt.md" class="row mobile-sticky-header">
                <div class="col-1">
                    <q-btn :size="$q.screen.lt.md ? '18px' : '28px'" flat dense no-caps icon="menu" class="logout-link" @click="showDrawer" />
                </div>
                <div class="col-10 text-center">
                    <img class="brand-logo-sera" src="../../assets/SERA_LOGO.png" />
                </div>
                <div class="col-1">
                    <q-btn :size="$q.screen.lt.md ? '18px' : '28px'" flat dense no-caps icon="logout" class="logout-link" @click="logout" />
                </div>
            </div>
            <header class="user-header">
                <div v-if="!$q.screen.lt.md" class="row">
                    <div class="col-11 items-center logo-class">
                        <div class="menu-btn">
                          <q-btn v-if="!$q.screen.lt.md" flat dense rounded @click="showDrawer">
                              <q-icon name="menu" :size="$q.screen.lt.md ? '30px' : '28px'" />
                          </q-btn>
                      </div>
                        <img class="brand-logo-sera" src="../../assets/SERA_LOGO.png" />
                    </div>
                    <div class="col-1 logout-btn">
                        <q-btn :size="$q.screen.lt.md ? '18px' : '20px'" flat dense no-caps icon="logout" class="logout-link" @click="logout" />
                    </div>
                </div>
                <div class="brand-mark row">
                    <div class="col-1"></div>
                    <div class="header-content col-11">
                        <h1>User Management</h1>
                        <p class="header-copy sub-heading">Create user accounts, assign roles, and link dealers only where required.</p>
                    </div>
                </div>
            </header> -->

            <!-- CREATE USER FORM -->
            <q-form ref="createForm" @submit.prevent="handleFormValidation">
                <section class="create-card">
                    <div class="section-title">
                        <span class="section-icon"><q-icon name="person_add" /></span>
                        <div>
                            <h2>New user</h2>
                            <p>Fill in the details to create an account.</p>
                        </div>
                    </div>

                    <div class="form-grid">
                        <div class="field-item">
                            <q-input
                                v-model.trim="form.fullName"
                                outlined
                                dense
                                label="Full Name *"
                                :rules="[required]"
                                class="formField"
                                hide-bottom-space
                            />
                        </div>
                        <div class="field-item">
                            <q-input
                                v-model.trim="form.userId"
                                outlined
                                dense
                                label="User ID *"
                                :rules="[required]"
                                class="formField"
                                hide-bottom-space
                                autocomplete="off"
                                @input="form.userId = form.userId?.toUpperCase()?.replace(/[^A-Z0-9]/g, '')"
                            />
                        </div>
                        <div class="field-item">
                            <q-input
                                v-model.trim="form.email"
                                outlined
                                dense
                                type="email"
                                label="Email Address *"
                                class="formField"
                                hide-bottom-space
                            />
                        </div>
                        <div class="field-item">
                            <q-input
                                v-model="form.password"
                                outlined
                                dense
                                :type="showPassword ? 'text' : 'password'"
                                label="Initial Password *"
                                :rules="[required]"
                                class="formField"
                                autocomplete="new-password"
                                hide-bottom-space
                            >
                                <template v-slot:append>
                                    <q-icon
                                        :name="showPassword ? 'visibility_off' : 'visibility'"
                                        class="cursor-pointer"
                                        @click="showPassword = !showPassword"
                                    />
                                </template>
                            </q-input>
                        </div>

                        <div class="field-item">
                            <!-- <q-select
                v-model="form.userType"
                :options="userTypeOptions.map((d) => d.userTypeName)"
                :key="userTypeOptions.length"
                outlined
                dense
                label="User Type *"
                :rules="[required]"
                class="formField"
                hide-bottom-space
                @update:model-value="onCreateRoleChange"
              /> -->
                            <template v-if="$q.screen.gt.md">
                                <custom-select
                                    :value="form.userType"
                                    model="userType"
                                    :options="userTypeOptions.map((d) => d.userTypeName)"
                                    :key="userTypeOptions.length"
                                    outlined
                                    dense
                                    label="User Type *"
                                    :rules="[required]"
                                    @change="onCreateRoleChange"
                                    class="formField"
                                    :disable="false"
                                />
                            </template>
                            <advance-search-select
                                v-else
                                :value="form.userType"
                                model="userType"
                                :options="userTypeOptions.map((e) => e.userTypeName)"
                                :key="userTypeOptions?.length"
                                @change="onCreateRoleChange"
                                outlined
                                dense
                                label="User Type *"
                                :rules="[required]"
                                no-error-icon
                                class="formField"
                                hide-bottom-space
                                :disable="false"
                            />
                        </div>
                        <div class="field-item">
                            <!-- <q-select
                v-model="form.role"
                :options="roleOptions.map((d) => d.ugName)"
                :Key="roleOptions?.length"
                outlined
                dense
                label="Role *"
                :rules="[required]"
                class="formField"
                hide-bottom-space
                @update:model-value="onCreateRoleChange"
              /> -->
                            <template v-if="$q.screen.gt.md">
                                <custom-select
                                    :value="form.role"
                                    model="role"
                                    :options="roleOptions.map((d) => d.name)"
                                    :Key="roleOptions?.length"
                                    outlined
                                    dense
                                    label="Role *"
                                    :rules="[required]"
                                    @change="onCreateRoleChange"
                                    class="formField"
                                />
                            </template>
                            <advance-search-select
                                v-else
                                :value="form.role"
                                model="role"
                                :options="roleOptions.map((e) => e.name)"
                                :key="roleOptions?.length"
                                @change="onCreateRoleChange"
                                outlined
                                dense
                                label="Role *"
                                :rules="[required]"
                                no-error-icon
                                class="formField"
                                :disable="false"
                                hide-bottom-space
                            />
                        </div>

                        <div class="field-item">
                            <!-- <q-select
                v-model="form.dealer"
                :options="dealerOptions.map((d) => d.dealerName)"
                :key="dealerOptions.length"
                outlined
                dense
                label="Select dealer"
                :rules="[required]"
                class="formField"
                hide-bottom-space
              />
              <p class="field-hint">
                Dealer is optional and will be ignored for non-dealer roles.
              </p> -->
                            <template v-if="$q.screen.gt.md">
                                <custom-select
                                    :value="form.dealer"
                                    model="dealer"
                                    ref="dealer"
                                    :options="dealerOptions.map((d) => d.name)"
                                    :key="dealerOptions.length"
                                    outlined
                                    dense
                                    label="Dealer *"
                                    :rules="form.userType == 'Dealer' ? [required] : []"
                                    @change="onCreateRoleChange"
                                    class="formField"
                                />
                            </template>
                            <advance-search-select
                                v-else
                                :value="form.dealer"
                                model="dealer"
                                ref="dealer"
                                :options="dealerOptions.map((e) => e.name)"
                                :key="dealerOptions?.length"
                                @change="onCreateRoleChange"
                                outlined
                                dense
                                label="Dealer *"
                                :rules="form.userType == 'Dealer' ? [required] : []"
                                no-error-icon
                                class="formField"
                                :disable="false"
                                hide-bottom-space
                            />
                        </div>
                    </div>
                </section>

                <footer class="form-actions">
                    <q-space />
                    <q-btn
                        unelevated
                        no-caps
                        label="Create user"
                        icon-right="check_circle"
                        class="primary-button"
                        :loading="isSaving"
                        :disable="isSaving || !userRole.create"
                        @click="handleFormValidation"
                    />
                </footer>
            </q-form>

            <!-- ================= USER LIST (q-table: grid on mobile, table on desktop) ================= -->
            <section class="list-card">
                <div class="list-card-header">
                    <div class="section-title">
                        <span class="section-icon"><q-icon :size="$q.screen.lt.md ? 'md' : ''" name="group" /></span>
                        <div>
                            <h2>Existing users</h2>
                        </div>
                    </div>

                    <q-btn size="lg" flat dense round icon="refresh" class="refresh-btn" :loading="isLoading" @click="getUsers">
                        <q-tooltip>Refresh</q-tooltip>
                    </q-btn>
                </div>

                <q-table
                    ref="userTable"
                    :data="users"
                    :columns="columns"
                    row-key="userId"
                    flat
                    dense
                    :grid="isMobile"
                    :loading="isLoading"
                    :pagination.sync="pagination"
                    :rows-per-page-options="[0]"
                    :hide-pagination="true"
                    class="user-q-table"
                >
                    <!-- Loading state -->
                    <template v-if="isLoading" v-slot:loading>
                        <div class="loading-state">
                            <q-spinner size="40px" color="primary" />
                            <span>Loading users...</span>
                        </div>
                    </template>

                    <!-- Empty state -->
                    <template v-if="!isLoading" v-slot:no-data>
                        <div class="empty-state">
                            <div class="empty-icon">
                                <q-icon name="person_off" size="38px" />
                            </div>
                            <h3>No users found</h3>
                            <p>Create your first user using the form above.</p>
                        </div>
                    </template>

                    <!-- ===== DESKTOP ROW (table mode) ===== -->
                    <template v-if="!isLoading" v-slot:body="props">
                        <q-tr :props="props">
                            <q-td key="userId" :props="props">
                                <span class="cell-strong">{{ props.row.userId }}</span>
                            </q-td>

                            <q-td key="email" :props="props">
                                <span class="normal-value">{{ props.row.email || '—' }}</span>
                            </q-td>

                            <q-td key="name" :props="props">
                                <span class="normal-value">{{ props.row.name }}</span>
                            </q-td>

                            <q-td key="userType" :props="props">
                                <span class="normal-value">{{ props.row.userType || '—' }}</span>
                            </q-td>
                            <q-td key="dealer" :props="props">
                                <span class="normal-value">{{ props.row.dealer || '—' }}</span>
                            </q-td>

                            <q-td key="role" :props="props">
                                <span class="role-pill">{{ props.row.role }}</span>
                            </q-td>

                            <q-td key="status" :props="props">
                                <span class="status-badge" :class="props.row.status.toLowerCase()">{{ props.row.status }}</span>
                            </q-td>

                            <q-td class="tableRowsFields" key="edit" :props="props">
                                <div class="inline-group">
                                    <q-input
                                        v-model.trim="props.row.editName"
                                        outlined
                                        dense
                                        hide-bottom-space
                                        class="tableField"
                                        placeholder="Name"
                                        :disable="!userRole.edit"
                                        :error="isValidField && !props.row.editName && userValidationObj[props.row.uniqueId]"
                                        no-error-icon
                                    />
                                    <q-input
                                        v-model.trim="props.row.editEmail"
                                        outlined
                                        dense
                                        hide-bottom-space
                                        class="tableField"
                                        placeholder="Email"
                                        :disable="!userRole.edit"
                                    />
                                    <template v-if="$q.screen.gt.md">
                                        <q-select
                                            v-model="props.row.editUserType"
                                            :options="userTypeOptions.map((d) => d.userTypeName)"
                                            :key="userTypeOptions?.length"
                                            outlined
                                            dense
                                            :error="isValidField && !props.row.editUserType && userValidationObj[props.row.uniqueId]"
                                            no-error-icon
                                            hide-bottom-space
                                            class="tableField"
                                            :disable="!userRole.edit"
                                        />
                                    </template>
                                    <advance-search-select
                                        v-else
                                        :value="props.row.editUserType"
                                        :model="`editUserType-${props.rowIndex}`"
                                        :options="userTypeOptions.map((e) => e.userTypeName)"
                                        :key="userTypeOptions?.length"
                                        @change="handlRowSelect"
                                        outlined
                                        dense
                                        label="Select User Type *"
                                        :error="isValidField && !props.row.editUserType && userValidationObj[props.row.uniqueId]"
                                        no-error-icon
                                        class="formField formFieldDetail"
                                        hide-bottom-space
                                        :disable="!userRole.edit"
                                    />
                                    <template v-if="$q.screen.gt.md">
                                        <q-select
                                            v-model="props.row.editRole"
                                            :options="roleOptions.map((d) => d.name)"
                                            :Key="roleOptions?.length"
                                            outlined
                                            dense
                                            hide-bottom-space
                                            class="tableField"
                                            :error="isValidField && !props.row.editRole && userValidationObj[props.row.uniqueId]"
                                            no-error-icon
                                            :disable="!userRole.edit"
                                        />
                                    </template>
                                    <advance-search-select
                                        v-else
                                        :value="props.row.editRole"
                                        :model="`editRole-${props.rowIndex}`"
                                        :options="roleOptions.map((e) => e.name)"
                                        :key="roleOptions?.length"
                                        @change="handlRowSelect"
                                        outlined
                                        dense
                                        label="Role *"
                                        :error="isValidField && !props.row.editRole && userValidationObj[props.row.uniqueId]"
                                        no-error-icon
                                        class="formField formFieldDetail"
                                        hide-bottom-space
                                        :disable="!userRole.edit"
                                    />
                                    <template v-if="$q.screen.gt.md">
                                        <q-select
                                            v-model="props.row.editDealer"
                                            :options="dealerOptions.map((d) => d.name)"
                                            :key="dealerOptions.length"
                                            outlined
                                            dense
                                            :error="isValidField && props.row.editUserType === 'Dealer' ? !props.row.editDealer && userValidationObj[props.row.uniqueId]: false"
                                            hide-bottom-space
                                            no-error-icon
                                            class="tableField"
                                            :disable="!userRole.edit"
                                        />
                                    </template>
                                    <advance-search-select
                                        v-else
                                        :value="props.row.editDealer"
                                        :model="`editDealer-${props.rowIndex}`"
                                        :options="dealerOptions.map((e) => e.name)"
                                        :key="dealerOptions?.length"
                                        @change="handlRowSelect"
                                        outlined
                                        dense
                                        label="Select Dealer *"
                                        :error="isValidField && props.row.editUserType === 'Dealer' ? !props.row.editDealer && userValidationObj[props.row.uniqueId] : false"
                                        no-error-icon
                                        class="formField formFieldDetail"
                                        hide-bottom-space
                                        :disable="!userRole.edit"
                                    />

                                    <q-btn :disable="!userRole.edit" unelevated no-caps label="Save" class="save-button" @click="saveUser(props.row)" />
                                </div>
                            </q-td>

                            <q-td key="reset" :props="props">
                                <div class="inline-group">
                                    <q-input
                                        v-model="props.row.newPassword"
                                        outlined
                                        dense
                                        type="password"
                                        hide-bottom-space
                                        class="tableField"
                                        placeholder="New password"
                                        :error="isValidPassword && !props.row.newPassword && userValidationObj[props.row.uniqueId]"
                                        no-error-icon
                                        :disable="!userRole.resetPassword"
                                    />
                                    <q-btn :disable="!userRole.resetPassword" unelevated no-caps outline label="Reset" class="reset-button" @click="saveUser(props.row, true)" />
                                </div>
                            </q-td>
                        </q-tr>
                    </template>

                    <!-- ===== MOBILE CARD (grid mode) ===== -->
                    <template v-if="!isLoading" v-slot:item="props">
                        <article class="user-card shadow-4 q-ma-sm" :class="{ 'is-expanded': isExpanded(props.row) }">
                            <div class="user-card-top" @click="toggleExpand(props.row)">
                                <div>
                                    <span class="user-label">USER ID</span>
                                    <strong class="user-number">{{ props.row.userId }}</strong>
                                    <small class="user-email">{{ props.row.email || '—' }}</small>
                                </div>

                                <div class="header-right">
                                    <span class="status-badge" :class="props.row.status.toLowerCase()">{{ props.row.status }}</span>
                                    <q-icon name="expand_more" class="expand-icon" size="22px" />
                                </div>
                            </div>

                            <q-slide-transition>
                                <div v-show="isExpanded(props.row)">
                                    <div class="card-details">
                                        <div class="detail-item">
                                            <span>Name</span>
                                            <strong>{{ props.row.name }}</strong>
                                        </div>
                                        <div class="detail-item">
                                            <span>User Type</span>
                                            <strong>{{ props.row.userType || '--' }}</strong>
                                        </div>
                                        <div class="detail-item">
                                            <span>Dealer</span>
                                            <strong>{{ props.row.dealer || '--' }}</strong>
                                        </div>
                                        <div class="detail-item">
                                            <span>Role</span>
                                            <strong
                                                ><span class="role-pill">{{ props.row.editRole }}</span></strong
                                            >
                                        </div>
                                    </div>

                                    <div class="card-divider"></div>

                                    <div class="edit-block">
                                        <span class="block-label">Edit user</span>
                                        <div class="edit-fields">
                                            <q-input
                                                v-model.trim="props.row.editName"
                                                outlined
                                                dense
                                                label="Name"
                                                class="formField rowFields"
                                                hide-bottom-space
                                                :error="!props.row.editName && userValidationObj[props.row.uniqueId]"
                                                no-error-icon
                                                :disable="!userRole.edit"
                                            />
                                            <q-input
                                                v-model.trim="props.row.editEmail"
                                                outlined
                                                dense
                                                label="Email"
                                                class="formField rowFields"
                                                hide-bottom-space
                                                :disable="!userRole.edit"
                                            />
                                            <template v-if="$q.screen.gt.md">
                                                <q-select
                                                    v-model="props.row.editUserType"
                                                    :options="userTypeOptions.map((d) => d.userTypeName)"
                                                    :key="userTypeOptions?.length"
                                                    outlined
                                                    dense
                                                    :error="!props.row.editUserType && userValidationObj[props.row.uniqueId]"
                                                    no-error-icon
                                                    label="Select User Type"
                                                    class="formField rowFields"
                                                    hide-bottom-space
                                                    :disable="!userRole.edit"
                                                />
                                            </template>
                                            <advance-search-select
                                                v-else
                                                :value="props.row.editUserType"
                                                :model="`editUserType-${props.rowIndex}`"
                                                :options="userTypeOptions.map((e) => e.userTypeName)"
                                                :key="userTypeOptions?.length"
                                                @change="handlRowSelect"
                                                outlined
                                                dense
                                                label="Select User Type *"
                                                :error="!props.row.editUserType && userValidationObj[props.row.uniqueId]"
                                                no-error-icon
                                                class="formField rowFields"
                                                hide-bottom-space
                                               :disable="!userRole.edit"
                                            />
                                            <template v-if="$q.screen.gt.md">
                                                <q-select
                                                    v-model="props.row.editRole"
                                                    :options="roleOptions.map((d) => d.name)"
                                                    :Key="roleOptions?.length"
                                                    outlined
                                                    :error="!props.row.editRole && userValidationObj[props.row.uniqueId]"
                                                    no-error-icon
                                                    dense
                                                    label="Role"
                                                    class="formField rowFields"
                                                    hide-bottom-space
                                                    :disable="!userRole.edit"
                                                />
                                            </template>
                                            <advance-search-select
                                                v-else
                                                :value="props.row.editRole"
                                                :model="`editRole-${props.rowIndex}`"
                                                :options="roleOptions.map((e) => e.name)"
                                                :key="roleOptions?.length"
                                                @change="handlRowSelect"
                                                outlined
                                                dense
                                                label="Role *"
                                                :error="!props.row.editRole && userValidationObj[props.row.uniqueId]"
                                                no-error-icon
                                                class="formField rowFields"
                                                hide-bottom-space
                                                :disable="!userRole.edit"
                                            />
                                            <template v-if="$q.screen.gt.md">
                                                <q-select
                                                    v-model="props.row.editDealer"
                                                    :options="dealerOptions.map((d) => d.name)"
                                                    :key="dealerOptions?.length"
                                                    outlined
                                                    :error="props.row.editUserType === 'Dealer' ? !props.row.editDealer && userValidationObj[props.row.uniqueId]: false"
                                                    dense
                                                    no-error-icon
                                                    label="Select dealer"
                                                    class="formField rowFields"
                                                    hide-bottom-space
                                                    :disable="!userRole.edit"
                                                />
                                            </template>
                                            <advance-search-select
                                                v-else
                                                :value="props.row.editDealer"
                                                :model="`editDealer-${props.rowIndex}`"
                                                :options="dealerOptions.map((e) => e.name)"
                                                :key="dealerOptions?.length"
                                                @change="handlRowSelect"
                                                outlined
                                                dense
                                                label="Select dealer *"
                                                :error="props.row.editUserType === 'Dealer' ? !props.row.editDealer && userValidationObj[props.row.uniqueId]: false"
                                                no-error-icon
                                                class="formField rowFields"
                                                hide-bottom-space
                                                :disable="!userRole.edit"
                                            />

                                            <q-btn :disable="!userRole.edit" unelevated no-caps label="Save" class="save-button full-width" @click="saveUser(props.row)" />
                                        </div>
                                    </div>

                                    <div class="card-divider"></div>

                                    <div class="edit-block">
                                        <span class="block-label">Reset password</span>
                                        <div class="reset-fields">
                                            <q-input
                                                v-model="props.row.newPassword"
                                                outlined
                                                dense
                                                type="password"
                                                label="New password"
                                                class="formField"
                                                hide-bottom-space
                                                :error="isValidPassword && !props.row.newPassword && userValidationObj[props.row.uniqueId]"
                                                no-error-icon
                                                :disable="!userRole.resetPassword"
                                            />
                                            <q-btn :disable="!userRole.resetPassword" unelevated no-caps outline label="Reset" class="reset-button" @click="saveUser(props.row, true)" />
                                        </div>
                                    </div>
                                </div>
                            </q-slide-transition>
                        </article>
                    </template>
                </q-table>

                <!-- CUSTOM FOOTER -->
                <div v-if="!isLoading && users.length" :class="isMobile ? 'mobile-pagination q-mb-lg' : 'pagination-wrapper'">
                    <span v-if="!isMobile" class="pagination-info">
                        Showing {{ paginationStart }} - {{ paginationEnd }} of
                        {{ users.length }}
                    </span>

                    <q-pagination
                        v-model="pagination.page"
                        :max="totalPages"
                        :max-pages="isMobile ? 5 : 6"
                        direction-links
                        :boundary-links="!isMobile"
                        :size="$q.screen.lt.md ? 'lg' : 'md'"
                    />
                </div>
            </section>
        </section>
        <drawer ref="refDrawer" />
    </main>
</template>

<script>
import apis from '@/utilities';
import axios from 'axios';
import Drawer from '../layout/drawer.vue';
import appHeader from "@/views/components/header.vue"
import { v4 as uuidV4 } from "uuid";


const emptyForm = () => ({
    fullName: '',
    userId: '',
    email: '',
    password: '',
    role: '',
    dealer: '',
    userType: '',
});

export default {
    name: 'UserManagement',
    components: { drawer: Drawer, appHeader },
    data() {
        return {
            form: emptyForm(),
            showPassword: false,
            isSaving: false,
            isLoading: false,

            roleOptions: [],
            dealerOptions: [],
            userTypeOptions: [],
            users: [],

            pagination: {
                page: 1,
                rowsPerPage: 8,
            },

            columns: [
                { name: 'userId', label: 'User ID', field: 'userId', align: 'left' },
                { name: 'email', label: 'Email', field: 'email', align: 'left' },
                { name: 'name', label: 'Name', field: 'name', align: 'left' },
                {
                    name: 'userType',
                    label: 'User Type',
                    field: 'userType',
                    align: 'left',
                },
                { name: 'dealer', label: 'Dealer', field: 'dealer', align: 'left' },
                { name: 'role', label: 'Role', field: 'role', align: 'left' },
                { name: 'status', label: 'Status', field: 'status', align: 'left' },
                { name: 'edit', label: 'Edit User', field: 'edit', align: 'left' },
                {
                    name: 'reset',
                    label: 'Reset Password',
                    field: 'reset',
                    align: 'left',
                },
            ],

            expandedRows: [],
            inputMasking: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
            userValidationObj:{},
            isValidPassword:false,
            isValidField: false,
            userRole:{}
        };
    },
    computed: {
        url() {
            return this.$store.getters.url;
        },
        isMobile() {
            return this.$q.screen.width < 1024;
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.users.length / this.pagination.rowsPerPage));
        },
        paginationStart() {
            if (!this.users.length) return 0;
            return (this.pagination.page - 1) * this.pagination.rowsPerPage + 1;
        },
        paginationEnd() {
            return Math.min(this.pagination.page * this.pagination.rowsPerPage, this.users.length);
        },
    },
    mounted() {
        this.getUsers();
        this.getUserType();
        this.getUserGroup();
        this.getDealers();
        this.setUserRole();
    },
    methods: {
        required(value) {
            console.log('value Req: ', value);
            return !!value || 'This field is required';
        },
        isEmail(value) {
            return /.+@.+\..+/.test(value) || 'Enter a valid email';
        },
        onCreateRoleChange(model, value) {
            console.log('value: ', value);
            console.log('model: ', model);
            this.form[model] = value;

            if (model === 'userType') {
                this.onUserTypeChange();
            }
        },
        handlRowSelect(model, value) {
            console.log('model: ', model, value);
            const mdl = model.split('-')[0];
            const index = model.split('-')[1];
            this.users[index][mdl] = value;

            //   this.users = [...this.users];
        },

        async getDealers() {
            try {
                const response = await axios.get(`${this.url}/${apis.GetProjectDealers}?isUserCreate=true`);

                this.dealerOptions = response.data.data;
            } catch (err) {
                this.$store.dispatch('triggerUnauthorizedError', err);
                console.error(err.response || err);
            }
        },
        async getUserGroup() {
            try {
                const response = await axios.get(`${this.url}/${apis.GetUserGroup}`);
                this.roleOptions = response.data.data;
            } catch (err) {
                this.$store.dispatch('triggerUnauthorizedError', err);
                console.error(err.response || err);
            }
        },
        async getUserType() {
            try {
                const response = await axios.get(`${this.url}/${apis.GetUserType}`);
                this.userTypeOptions = !this.userRole.assignDealer ? response.data.data.fillter(d => d.userTypeName !== 'Dealer') : response.data.data;
            } catch (err) {
                this.$store.dispatch('triggerUnauthorizedError', err);
                console.error(err.response || err);
            }
        },
        async handleFormValidation() {
            const valid = await this.$refs.createForm.validate();
            console.log('valid: ', valid);

            if (!valid) return;

            await this.createUser();
        },
        setUserRole() {
            const {
                menu: { permissions },
            } = this.$store.state;

            if (permissions) {
                permissions?.map((m) => {
                    const accesstype = m.code?.split('.');
                    this.userRole[accesstype[accesstype?.length - 1]] = true;
                });
                console.log('userRole: ', this.userRole);
            }
        },
        async createUser() {
            const UserGroup = this.roleOptions.find((d) => d.name === this.form.role)?.id;
            const DealerId = this.dealerOptions.find((d) => d.name === this.form.dealer)?.id;
            const UserTypeId = this.userTypeOptions.find((d) => d.userTypeName === this.form.userType)?.userTypeId;
            const payload = {
                FullName: this.form.fullName,
                UserId: this.form.userId,
                Email: this.form.email,
                PasswordHash: this.form.password,
                RoleId:UserGroup,
                DealerId,
                UserTypeId,
            };

            this.isSaving = true;
            try {
                const response = await axios.post(`${this.url}/${apis.SaveUser}`, payload);
                this.globalNotification(response.data.message, response.data.validationState);
                if (response.data.success) {
                    this.form = emptyForm();
                    this.showPassword = false;
                    this.$refs.createForm.reset();
                    this.$refs.createForm.resetValidation();
                    this.getUsers();
                    this.userValidationObj = {}
                    this.isValidPassword = false
                    this.isValidField = false
                }
            } catch (err) {
                this.$store.dispatch('triggerUnauthorizedError', err);
                console.error(err.response || err);
            }
            this.isSaving = false;
        },

        async getUsers() {
            this.isLoading = true;
            this.users = [];
            this.userValidationObj = {}
            this.isValidPassword = false
            this.isValidField = false
            try {
                const response = await axios.get(`${this.url}/${apis.GetUsers}`);
                this.users = (response.data.data ?? []).map((u) => ({
                    ...u,
                    userId: u.userId,
                    email: u.email,
                    name: u.fullName,
                    userType: u.userTypeName,
                    dealer: u.dealerName,
                    status: u.isActive ? 'Active' : 'Inactive',
                    editName: u.fullName,
                    editEmail: u.email,
                    editRole: u.role,
                    editDealer: u.dealerName,
                    editUserType: u.userTypeName,
                    newPassword: '',
                    uniqueId: uuidV4()
                }));
            } catch (err) {
                this.$store.dispatch('triggerUnauthorizedError', err);
                console.error(err.response || err);
            } finally {
                this.isLoading = false;
            }
        },

        async saveUser(user, isCheck) {
            this.userValidationObj = {}
            this.isValidPassword = false
            this.isValidField = false
            if (isCheck && !user.newPassword) {
                this.isValidPassword = true
                this.userValidationObj[user.uniqueId] = true
                this.$q.notify({
                    progress: true,
                    type: 'warning',
                    message: 'Enter a new password first.',
                    position: 'bottom',
                });
                return;
            }

            const password = isCheck && { PasswordHash: user.newPassword };
            const FullName = user.editName
            const UserGroup = this.roleOptions.find((d) => d.name === user.editRole)?.id;
            const DealerId = this.dealerOptions.find((d) => d.name === user.editDealer)?.id;
            const UserTypeId = this.userTypeOptions.find((d) => d.userTypeName === user.editUserType)?.userTypeId;
            const isValidDealer =  UserTypeId === 1 ? DealerId : true
              if (
                FullName && 
                UserTypeId && 
                UserGroup &&
               isValidDealer
              ) {
            const payload = {
                UserId: user.userId,
                FullName,
                Email: user.editEmail,
                ...password,
                RoleId: UserGroup,
                DealerId,
                UserTypeId,
                Id: user.id,
                Role: user.editRole
            };
            try {
                const response = await axios.post(`${this.url}/${apis.SaveUser}`, payload);
                if (response.data.success) {
                    this.form = emptyForm();
                    this.showPassword = false;
                    this.getUsers();
                    this.userValidationObj = {}
                    this.isValidPassword = false
                    this.isValidField = false
                }
                this.globalNotification(response.data.message, response.data.validationState);
            } catch (err) {
                this.$store.dispatch('triggerUnauthorizedError', err);
                console.error(err.response || err);
            }
              } else {
                let errorList = []
                if(!FullName) errorList.push("Name")
                if(!UserTypeId) errorList.push("User Type")
                if(!UserGroup) errorList.push("Role")
                if(!isValidDealer) errorList.push("Dealer")
                const uniquerErrors = [...new Set(errorList)]
                if(uniquerErrors.length){
                    this.isValidField = true
                    this.userValidationObj[user.uniqueId] = true
                    this.$q.notify({
                      progress: true,
                      type: "warning",
                      message: `Select the required: (${uniquerErrors.join(", ")}) ${uniquerErrors.length === 1 ? "field" : "field's"}.`,
                      position: "bottom",
                    });
                }
              }
        },

        logout() {
            sessionStorage.setItem('token', null);
            this.$store.commit('logOutHandler');
        },
        showDrawer() {
            if (this.$refs.refDrawer) {
                this.$refs.refDrawer.toggleDrawer();
            }
        },
        isExpanded(row) {
            return this.expandedRows.includes(row.userId);
        },
        toggleExpand(row) {
            const index = this.expandedRows.indexOf(row.userId);
            if (index === -1) this.expandedRows.push(row.userId);
            else this.expandedRows.splice(index, 1);
        },
        onUserTypeChange() {
            this.$nextTick(() => {
                if (this.form.userType !== 'Dealer') {
                    this.$refs.dealer.resetValidation();
                    this.$refs.dealer.reset();
                } else {
                    this.$refs.dealer.validate();
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.scss';

/* ============================================================
   BASE = MOBILE FIRST
   ============================================================ */

.visit-page {
    min-height: 100vh;
    padding: 0;
    color: $primary;
    text-align: left;
}
.visit-shell {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
}

.brand-logo-sera {
    height: 26px;
    margin-bottom: 10px;
}

/* ================= HEADER ================= */
.user-header {
    min-height: 150px;
    width: 100%;
    padding: 40px 18px 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    color: $primary;
    position: relative;
    background: transparent;
  
    box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
}
.brand-mark {
    // width: 100%;
    height: 42px;
    // flex: 0 0 auto;
    // display: grid;
    // place-items: center;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
}
.header-content {
    min-width: 0;
}
h1 {
    margin: 0;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 700;
}
.header-copy {
    margin: 7px 0 0;
    font-size: 12px;
    opacity: 0.85;
}
.sub-heading {
    color: $magenta !important;
}
.header-actions {
    position: absolute;
    top: 14px;
    right: 14px;
    display: flex;
    gap: 8px;
}
.logout-link {
    color: $primary;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 18px;
}

.logout-btn {
    text-align: center;
}

.menu-btn {
    margin-right: 30px;
    text-align: left;
    display: none;
}

.mobile-sticky-header{
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
    background: #fff;
    padding: 18px 10px;
     box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}

/* ================= CREATE FORM ================= */
.create-card {
    padding: 20px 18px 15px;
    background: #fff;
    border-bottom: 1px solid #e5edef;
}
.section-title {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
}
.section-icon {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
    color: $primary;
    background: #e7f2f4;
    border-radius: 10px;
    flex-shrink: 0;
}
.section-title h2 {
    margin: 0;
    color: $primary;
    font-size: 17px;
}
.section-title p {
    margin: 3px 0 0;
    color: #73858a;
    font-size: 13px;
}
.form-grid {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -9px;
}
.field-item {
    flex: 1 1 100%;
    padding: 0 9px;
    margin-bottom: 18px;
}
.field-hint {
    margin: 8px 0 0;
    font-size: 12.5px;
    color: #73858a;
}
.formField :deep(.q-field__control) {
    height: 52px;
    min-height: 52px;
}
.form-actions {
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border-top: 1px solid #e5edef;
    justify-content: flex-end;
    margin-bottom: 22px;
    box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}
.primary-button {
    width: 100%;
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
    padding: 12px 0;
    font-size: 15px;
    font-weight: 600;
}

/* ================= LIST CARD ================= */
.list-card {
    background: #fff;
    overflow: hidden;
}
.list-card-header {
    padding: 20px 18px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.list-card-header .section-title {
    margin-bottom: 0;
}
.refresh-btn {
    color: $primary;
}

/* ================= Q-TABLE OVERRIDES ================= */
.user-q-table {
    :deep(.q-table__card) {
        box-shadow: none;
        background: transparent;
    }
    :deep(.q-table__middle) {
        box-shadow: none;
    }
    :deep(table) {
        width: 100%;
        min-width: 1500px;
        border-collapse: collapse;
    }
    :deep(thead tr th) {
        height: 50px;
        padding: 0 14px;
        color: #73858a;
        background: #f7fafb;
        border-bottom: 1px solid #e3ebed;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-align: left;
        text-transform: uppercase;
        white-space: nowrap;
    }
    :deep(tbody td) {
        padding: 10px 14px;
        color: #35525a;
        border-bottom: 1px solid #edf2f3;
        font-size: 13px;
        vertical-align: middle;
    }
    :deep(tbody tr:hover) {
        background: #f9fbfb;
    }
    :deep(.q-table__grid-content) {
        padding: 0 18px;
        display: block;
        background: #f5f8f9;
    }
    :deep(.q-table__grid-item) {
        padding: 0;
        margin-bottom: 12px;
        width: 100%;
    }
}

.cell-strong {
    color: $primary;
    font-weight: 700;
    white-space: nowrap;
}
.normal-value {
    color: #526a70;
}
.role-pill {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 999px;
    background: #e7f2f4;
    color: $primary;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
}
.status-badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
    background: #e6f7ec;
    color: #1e8a4c;
}
.status-badge.inactive {
    background: #fbeaea;
    color: #b3403f;
}

/* inline edit / reset groups inside a table cell (desktop) */
.inline-group {
    display: flex;
    align-items: center;
    gap: 8px;
}
.tableField {
   width: 260px;
}
.tableField :deep(.q-field__control) {
    height: 38px;
    min-height: 38px;
}
.save-button {
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
    padding: 0 16px;
    height: 36px;
    font-weight: 600;
    white-space: nowrap;
}
.reset-button {
    color: $primary;
    border: 1px solid $primary;
    border-radius: 8px;
    padding: 0 16px;
    height: 36px;
    font-weight: 600;
    white-space: nowrap;
}
.full-width {
    width: 100%;
}

/* ================= PAGINATION ================= */
.pagination-wrapper {
    min-height: 65px;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 25px;
    border-top: 1px solid #edf2f3;
}
.pagination-info {
    margin-right: auto;
    color: #87969a;
    font-size: 12px;
}
.mobile-pagination {
    min-height: 60px;
    padding: 10px;
    display: flex;
    justify-content: center;
    background: transparent;
    margin-bottom: 20px !important;
}

/* ================= LOADING / EMPTY ================= */
.loading-state,
.empty-state {
    min-height: 220px;
    width: 100%;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.loading-state {
    gap: 12px;
    color: #73858a;
    font-size: 13px;
}
.empty-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
    display: grid;
    place-items: center;
    color: $primary;
    background: #e7f2f4;
    border-radius: 50%;
}
.empty-state h3 {
    margin: 0;
    color: $primary;
    font-size: 18px;
}
.empty-state p {
    margin: 6px 0 0;
    color: #819297;
    font-size: 13px;
}

/* ================= MOBILE CARD (grid item) ================= */
.user-card {
    padding: 16px;
    background: #fff;
    border: 1px solid #e3ebed;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(27, 67, 77, 0.05);
    transition: box-shadow 0.2s ease;
}
.user-card-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    cursor: pointer;
}
.header-right {
    display: flex;
    align-items: center;
    gap: 8px;
}
.user-card.is-expanded {
    box-shadow: 0 6px 20px rgba(27, 67, 77, 0.1);
}
.expand-icon {
    color: #87969a;
    transition: transform 0.25s ease;
}
.user-card.is-expanded .expand-icon {
    transform: rotate(180deg);
    color: #146b80;
}
.user-label {
    display: block;
    margin-bottom: 3px;
    color: #8a9a9e;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
}
.user-number {
    display: block;
    color: $primary;
    font-size: 15px;
}
.user-email {
    display: block;
    color: #73858a;
    font-size: 12px;
    margin-top: 2px;
    word-break: break-all;
}
.card-details {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px 0;
    margin-top: 14px;
    border-top: 1px solid #edf2f3;
}
.detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.detail-item span {
    color: #91a1a5;
    font-size: 12px;
}
.detail-item strong {
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
    font-weight: 600;
}
.card-divider {
    height: 1px;
    background: #edf2f3;
    margin: 14px 0;
}
.block-label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #789096;
    margin-bottom: 10px;
}
.edit-fields,
.reset-fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.reset-fields {
    flex-direction: row;
    align-items: flex-start;
}
.reset-fields .formField {
    flex: 1;
}
.reset-fields .reset-button {
    height: 52px;
    flex-shrink: 0;
}

/* ============================================================
   TABLET (>= 641px)
   ============================================================ */
@media (min-width: 641px) {
    .visit-page {
        padding: 32px 16px;
    }
    .logo-class{
        display: flex;
        align-items: center;
    }

    .menu-btn {
        margin-right: 30px;
        text-align: left;
        display: inline-block;
    }
    .visit-header {
        min-height: 130px;
        padding: 30px 34px;
    }
    .brand-mark {
        // width: 48px;
        // margin-left: -60px;
        height: 48px;
    }
    h1 {
        font-size: 26px;
    }
    .header-copy {
        font-size: 14px;
    }
    .header-actions {
        position: static;
        margin-left: auto;
    }
    .create-card {
        padding: 25px 34px 18px;
    }
    .section-title h2 {
        font-size: 19px;
    }
    .section-title p {
        font-size: 14px;
    }
    .form-grid {
        margin: 0 -10px;
    }
    .field-item {
        flex: 1 1 calc(50% - 20px);
        margin: 0 10px 20px;
    }
    .formField :deep(.q-field__control) {
        height: 44px;
        min-height: 44px;
    }
    .form-actions {
        padding: 18px 34px;
    }
    .primary-button {
        width: auto;
        padding: 0 22px;
        height: 44px;
    }
    .list-card-header {
        padding: 25px 34px 18px;
    }
    .tableField {
        // max-width: 220px;
        width: 260px;
    }
    h1 {
        margin: 0;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 700;
    }
    
}
@media (max-width: 641px){
    .formField {
        min-height: 60px;
    }

    .formField :deep(.q-field__control) {
        height: 60px;
        min-height: 60px;
    }

    .formField :deep(.q-field__native) {
        min-height: 60px;
    }
}

/* ============================================================
   DESKTOP (>= 1024px) — table mode kicks in
   ============================================================ */
   @media (min-width: 1024px) {
     .formFieldDetail{
       width: 260px;
     }
   }
@media (min-width: 1024px) {
    .visit-shell {
        max-width: 100%;
    }
    .pagination-wrapper {
        justify-content: flex-end;
    }
         .user-header{
        background: #fff;
          border-radius: 20px 20px 0 0;
    }
     .tableField {
        // max-width: 220px;
        width: 260px;
    }
}

@media (min-width: 1201px) {
    .visit-shell {
        max-width: 90vw;
    }
        .user-header{
        background: #fff;
          border-radius: 20px 20px 0 0;
    }
    .tableField {
        // max-width: 220px;
        width: 260px;
    }
}

@media (max-width: 1024px) {
 .tableField {
        // max-width: 220px;
        width: 260px;
    }
}
</style>